<template>
  <mdb-container fluid>
    <FrontPage
      :imagesrc="localFrontPage.imagelink"
      :logosrc="localFrontPage.logolink"
      :benefittext="localFrontPage.benefitstext"
      :othertext="localFrontPage.othertext"
      :backgroundcolor="localFrontPage.backgroundcolor"
      :fontcolor="localFrontPage.fontcolor"
      :loadReady="loadReady"
    />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import FrontPage from "../components/FrontPage.vue";

export default {
  name: "FrontPagePreview",
  components: {
    mdbContainer,
    FrontPage,
  },
  props: {},
  data() {
    return {
      getfrontpagepath: "/2.0/newbe/unionfrontpage?sessionid=",
      loadReady: false,
      localFrontPage: {
        imagelink: "",
        logolink: "",
        benefitstext: "",
        othertext: "",
        backgroundcolor: "",
        fontcolor: "",
      },
    };
  },
  methods: {
    getPageId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    getFrontPage(frontpageid) {
      this.$notify.info({
        message: this.$t("loading_front_page"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(
          this.getfrontpagepath +
            this.$store.getters.getToken +
            "&frontpageid=" +
            frontpageid
        )
        .then((response) => {
          if (response.status == 200) {
            this.fillLocalFrontPage(response.data.unionfrontpages[0]);
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    fillLocalFrontPage(val) {
      this.localFrontPage.benefitstext = val.benefitstext;
      this.localFrontPage.othertext = val.othertext;
      this.localFrontPage.logolink = val.logolink;
      this.localFrontPage.imagelink = val.imagelink;
      this.localFrontPage.backgroundcolor = val.backgroundcolor;
      this.localFrontPage.fontcolor = val.fontcolor;
      console.log(val);
    },
    loadFrontPage() {
      this.getFrontPage(this.getPageId());
    },
  },
  mounted() {
    this.loadFrontPage();
  },
};
</script>

<style></style>
